import ajv from '@f/validation/ajv'
import { IUserIntrestInEvent } from '@f/validation/types/dataLayer'
import { UserIntrestInEventSchema } from '@f/validation/schema/datalayer/giftATree'

export const validateUserIntrestInEvent = ajv.compile<IUserIntrestInEvent>(UserIntrestInEventSchema)